module.exports = __webpack_public_path__ + "img/apple-pie-1.cadfefef.svg";